﻿export default class GoogleAnalyticsCustomDimensions {
  static MarketId() {
    return new GoogleAnalyticsCustomDimensions('marketId');
  }

  static PartnerName() {
    return new GoogleAnalyticsCustomDimensions('partnerName');
  }

  static BuilderCorporation() {
    return new GoogleAnalyticsCustomDimensions('builderCorp');
  }

  static CommunityName() {
    return new GoogleAnalyticsCustomDimensions('communityName');
  }

  static City() {
    return new GoogleAnalyticsCustomDimensions('city');
  }

  static PageType() {
    return new GoogleAnalyticsCustomDimensions('pageType');
  }

  static PartnerId() {
    return new GoogleAnalyticsCustomDimensions('partnerId');
  }

  static MarketName() {
    return new GoogleAnalyticsCustomDimensions('marketName');
  }

  static CommunityId() {
    return new GoogleAnalyticsCustomDimensions('communityId');
  }

  static UserId() {
    return new GoogleAnalyticsCustomDimensions('i_uid');
  }

  static CurrentPageNumber() {
    return new GoogleAnalyticsCustomDimensions('currentPageNumber');
  }

  static NeustarResponse() {
    return new GoogleAnalyticsCustomDimensions('n_response');
  }

  static OffMarket() {
    return new GoogleAnalyticsCustomDimensions('OffMarket');
  }

  static BuilderId() {
    return new GoogleAnalyticsCustomDimensions('builderId');
  }

  static BrandName() {
    return new GoogleAnalyticsCustomDimensions('brandName');
  }

  static PlanId() {
    return new GoogleAnalyticsCustomDimensions('planId');
  }

  static SpecId() {
    return new GoogleAnalyticsCustomDimensions('specId');
  }

  static IsPaid() {
    return new GoogleAnalyticsCustomDimensions('IsPaid');
  }

  static MatchingResults() {
    return new GoogleAnalyticsCustomDimensions('matchingResults');
  }

  static Counties() {
    return new GoogleAnalyticsCustomDimensions('counties');
  }

  static Location() {
    return new GoogleAnalyticsCustomDimensions('location');
  }

  static PriceReduction() {
    return new GoogleAnalyticsCustomDimensions('priceReduction');
  }

  static SearchWithinMapActivated() {
    return new GoogleAnalyticsCustomDimensions('searchWithinMapActivated');
  }

  constructor(dimension) {
    this.dimension = dimension;
  }

  getName() {
    return this.dimension;
  }
}
